export default {
  daysLate: {
    id: 'bo_sellers_customer_care_table_column_status_days_late',
    defaultMessage: '{count, plural, one {# day} other {# days}} late',
  },
  hoursLate: {
    id: 'bo_sellers_customer_care_table_column_status_hours_late',
    defaultMessage: '{count, plural, one {# hour} other {# hours}} late',
  },
  daysLeft: {
    id: 'bo_sellers_customer_care_table_column_status_days_left',
    defaultMessage: '{count, plural, one {# day} other {# days}} left',
  },
  hoursLeft: {
    id: 'bo_sellers_customer_care_table_column_status_hours_left',
    defaultMessage: '{count, plural, one {# hour} other {# hours}} left',
  },
  noActionNeeded: {
    id: 'bo_sellers_customer_care_table_column_status_no_action_needed',
    defaultMessage: 'No action needed',
  },
  upcoming: {
    id: 'bo_sellers_customer_care_table_column_status_upcoming',
    defaultMessage: 'Upcoming',
  },
  completed: {
    id: 'bo_sellers_customer_care_table_column_status_completed',
    defaultMessage: 'Completed',
  },
  todo: {
    id: 'bo_sellers_customer_care_table_column_status_todo',
    defaultMessage: 'To do',
  },
}
